import { ReactMarkdown } from 'react-markdown/lib/react-markdown'
import { StyledMarkdownContainer } from 'components/common/MarkdownDisplay/MarkdownDisplay.style'

export const MarkdownDisplay = ({ children }: { children: string }) => {
  return (
    <StyledMarkdownContainer>
      <ReactMarkdown linkTarget="_blank">{children}</ReactMarkdown>
    </StyledMarkdownContainer>
  )
}
